export const featuresList = [
  {
    title: 'Reclamevrij',
    icon: 'ban',
    content: 'Klaar met al die reclames? Nu geen advertenties meer op zowel app als web als je inlogt met je account.',
  },
  {
    title: 'Eigen Playlist',
    icon: 'list-alt',
    content: `
      Maak nu je eigen gepersonaliseerde playlist. 
      Bijvoorbeeld je Poezen playlist, VrijMiBo playlist of Peturrrrr de Vries playlist. 
      Deel je playlist met je vrienden of bekijk de playlist van iemand anders.
    `,
  },
  {
    title: 'Personalisatie',
    icon: 'user-circle',
    content: `
      <strong>Eigen profielpagina</strong><br/>
      Hier staan al je gegevens, gebruikersnaam, je statistieken en links naar alle overige features
      <br/><br/>
      <strong>Gepersonaliseerde voorpagina</strong><br/>
      Geef je eigen filters op om Dumpert te personaliseren op de voorpagina.
    `,
  },
  {
    title: 'Extra reaguurder features',
    icon: 'comment',
    content: `
      <strong>Eigen reaguursels terugkijken</strong><br/>
      Vergeten wat je met je zatte kop hebt gereaguurd gisteravond? 
      Nu kun je makkelijk je eigen (top)reaguursels teruglezen en je kapot schamen.
      <br/><br/>
      <strong>Eigen reaguursels aanpassen</strong><br/>
      Toch te snel op enter gedrukt? Binnen 1 minuut je eigen fouten weghalen.
    `,
  },
  {
    title: 'Extra video features',
    icon: 'file-upload',
    content: `
      <strong>Favorieten</strong><br/>
      Dat ene vage filmpje uit 2009 bewaren zodat je het later naar je moeder kan sturen: 
      Bewaar hem in je FAVORIETEN op web en app gesynct.
      <br/><br/>
      <strong>Ingestuurde uploads inzien</strong><br/>
      Inzicht in je eigen ingestuurde content die op Dumpert staat.
      <br/><br/>
      <strong>Bekijk later</strong><br/>
      Kijk later maar.
    `,
  },
  {
    title: 'Statistieken & Badges',
    icon: 'medal',
    content: `
      <strong>Uitgebreide statistieken:</strong><br/>
      Hoeveel comments heb ik geplaatst? Hoeveel kudo's heb ik uitgedeeld? 
      Hoeveel keer heb ik de puistenpopfilmpjes bekeken? Hier vind je alles terug.
      <br/><br/>
      <strong>Badges</strong><br/>
      100 filmpjes gedeeld: <strong>BADGE!</strong><br/>
      1000 comments geplaatst: <strong>BADGE!</strong><br/>
      50 Keer ingelogd: <strong>BADGE!</strong><br/>
      16 keer VrijMiBo gekeken: <strong>FAPBADGE</strong><br/>
      Alles en iedereen zijn moeder: Je krijgt een <strong>BADGE</strong>.<br/>
    `,
  },
];